export default __webpack_public_path__ + "static/media/dordgeboy.c8d7e73b.jpg";